import { Building, Home, Hotel, Map } from "lucide-react";

export const propertyTypes = [
	{
		value: "apartment",
		label: "Apartment",
		options: [
			{ value: "a", label: "Any Apartment", finalValue: { type: "apartment", gated: true, project: true } },
			{
				value: "a:n",
				label: "Only Apartment",
				finalValue: {
					type: "apartment",
					gated: true,
					project: true,
					penthouse: false,
					villament: false,
				},
				isCompleted: true,
			},
			{
				value: "a:p",
				label: "Penthouse",
				finalValue: {
					type: "apartment",
					gated: true,
					project: true,
					penthouse: true,
					villament: false,
				},
				isCompleted: true,
			},
			{
				value: "a:v",
				label: "Villament",
				finalValue: {
					type: "apartment",
					gated: true,
					project: true,
					villament: true,
					penthouse: false,
				},
				isCompleted: true,
			},
		],
	},
	{
		value: "house",
		label: "House",
		options: [
			// gated, project, single, villa, villaType mandatory
			{ value: "h", label: "Any House", finalValue: { type: "house", villa: false } },
			// {
			// 	value: 'h:g-',
			// 	label: 'House in Gated Community',
			// 	options: [
			// 		{value: 'h:g', label: 'Any Gated Community House', finalValue: {type: 'house', gated: true, project: false, villa: false}},
			// 		{
			// 			value: 'h:g:s',
			// 			label: 'Single Family House (GC)',
			// 			finalValue: {
			// 				type: 'house', gated: true, project: false, single: true, villa: false, villaType: null,
			// 			},
			// 			isCompleted: true,
			// 		},
			// 		{
			// 			value: 'h:g:m',
			// 			label: 'Multi Family House (GC)',
			// 			finalValue: {
			// 				type: 'house', gated: true, project: false, single: false, villa: false, villaType: null,
			// 			},
			// 			isCompleted: true,
			// 		},
			// 	],
			// },
			{
				value: "h:p-",
				label: "House in a Project/Community",
				options: [
					{
						value: "h:p",
						label: "Any House in a Project/Community",
						finalValue: { type: "house", gated: true, project: true, villa: false },
					},
					{
						value: "h:p:s",
						label: "Single Family House in Project/Community",
						finalValue: {
							type: "house",
							gated: true,
							project: true,
							single: true,
							villa: false,
							villaType: null,
						},
						isCompleted: true,
					},
					{
						value: "h:p:m",
						label: "Multi Family House in Project/Community",
						finalValue: {
							type: "house",
							gated: true,
							project: true,
							single: false,
							villa: false,
							villaType: null,
						},
						isCompleted: true,
					},
				],
			},
			{
				value: "h:i-",
				label: "Independent House",
				options: [
					{
						value: "h:i",
						label: "Any Independent House",
						finalValue: { type: "house", gated: false, project: false, villa: false },
					},
					{
						value: "h:i:s",
						label: "Single Family House (I)",
						finalValue: {
							type: "house",
							gated: false,
							project: false,
							single: true,
							villa: false,
							villaType: null,
						},
						isCompleted: true,
					},
					{
						value: "h:i:m",
						label: "Multi Family House (I)",
						finalValue: {
							type: "house",
							gated: false,
							project: false,
							single: false,
							villa: false,
							villaType: null,
						},
						isCompleted: true,
					},
				],
			},
		],
	},
	{
		value: "villa",
		label: "Villa",
		options: [
			// gated, project, single, villa, villaType mandatory
			{
				value: "v",
				label: "Any Villa",
				finalValue: {
					type: "house",
					gated: true,
					project: true,
					villa: true,
					single: true,
				},
			},
			{
				value: "v:s",
				label: "Standalone (Villa)",
				finalValue: {
					type: "house",
					gated: true,
					project: true,
					villa: true,
					single: true,
					villaType: "standalone",
				},
				isCompleted: true,
			},
			{
				value: "v:1",
				label: "1-2 (Villa)",
				finalValue: {
					type: "house",
					gated: true,
					project: true,
					villa: true,
					single: true,
					villaType: "1-2",
				},
				isCompleted: true,
			},
			{
				value: "v:r",
				label: "Row (Villa)",
				finalValue: {
					type: "house",
					gated: true,
					project: true,
					villa: true,
					single: true,
					villaType: "row",
				},
				isCompleted: true,
			},
		],
	},
	{
		value: "plot",
		label: "Plot",
		options: [
			// gated, project mandatory
			{ value: "p", label: "Any Plot", finalValue: { type: "plot" } },
			{
				value: "p:p",
				label: "Gated Builder Plot",
				finalValue: { type: "plot", gated: true, project: true },
				isCompleted: true,
			},
			{
				value: "p:g",
				label: "Gated Community Plot",
				finalValue: { type: "plot", gated: true, project: false },
				isCompleted: true,
			},
			{
				value: "p:i",
				label: "Independent Plot",
				finalValue: { type: "plot", gated: false, project: false },
				isCompleted: true,
			},
		],
	},
];

export const propertyTypeOptions = [
	{
		value: "apartment",
		label: "Apartment",
		icon: Building,
		options: [
			{ value: "a", label: "Any", finalValue: { type: "apartment", gated: true, project: true } },
			{
				value: "a:n",
				label: "Only\nApartment",
				finalValue: { type: "apartment", gated: true, project: true, penthouse: false, villament: false },
			},
			{
				value: "a:p",
				label: "Penthouse",
				finalValue: { type: "apartment", gated: true, project: true, penthouse: true, villament: false },
			},
			{
				value: "a:v",
				label: "Villament",
				finalValue: { type: "apartment", gated: true, project: true, villament: true, penthouse: false },
			},
		],
	},
	{
		value: "house",
		label: "House",
		icon: Home,
		options: [
			{ value: "h", label: "Any", finalValue: { type: "house", villa: false } },
			// { value: 'h:g-', label: 'House in Gated Community', options: [ ... ] },
			{
				value: "h:p-",
				label: "In Project / Community",
				options: [
					{
						value: "h:p",
						label: "In Project / Community",
						finalValue: { type: "house", gated: true, project: true, villa: false },
					},
					{
						value: "h:p:s",
						label: "Single Family House in Project/Community",
						finalValue: { type: "house", gated: true, project: true, single: true, villa: false, villaType: null },
					},
					{
						value: "h:p:m",
						label: "Multi Family House in Project/Community",
						finalValue: { type: "house", gated: true, project: true, single: false, villa: false, villaType: null },
					},
				],
			},
			{
				value: "h:i-",
				label: "Independent",
				options: [
					{
						value: "h:i",
						label: "Any Independent House",
						finalValue: { type: "house", gated: false, project: false, villa: false },
					},
					{
						value: "h:i:s",
						label: "Single Family House (I)",
						finalValue: { type: "house", gated: false, project: false, single: true, villa: false, villaType: null },
					},
					{
						value: "h:i:m",
						label: "Multi Family House (I)",
						finalValue: { type: "house", gated: false, project: false, single: false, villa: false, villaType: null },
					},
				],
			},
		],
	},
	{
		value: "villa",
		label: "Villa",
		icon: Hotel,
		options: [
			{
				value: "v",
				label: "Any",
				finalValue: { type: "house", gated: true, project: true, villa: true, single: true },
			},
			{
				value: "v:s",
				label: "Standalone",
				finalValue: { type: "house", gated: true, project: true, villa: true, single: true, villaType: "standalone" },
			},
			{
				value: "v:1",
				label: "One of Two",
				finalValue: { type: "house", gated: true, project: true, villa: true, single: true, villaType: "1-2" },
			},
			{
				value: "v:r",
				label: "Row House",
				finalValue: { type: "house", gated: true, project: true, villa: true, single: true, villaType: "row" },
			},
		],
	},
	{
		value: "plot",
		label: "Plot",
		icon: Map,
		options: [
			{ value: "p", label: "Any", finalValue: { type: "plot" } },
			{ value: "p:p", label: "Gated Builder Project", finalValue: { type: "plot", gated: true, project: true } },
			{ value: "p:g", label: "Gated Community", finalValue: { type: "plot", gated: true, project: false } },
			{ value: "p:i", label: "Independent", finalValue: { type: "plot", gated: false, project: false } },
		],
	},
];
